/**
 * NovaDJ — "DJ" persona tile. Headphones on. The set is going well.
 * Timing: 0.5s bob · beat-synced bars. Geometry generated from the canonical Character
 * Bible catalog (nova.js) — regenerate rather than hand-editing paths.
 * Animations come from nova.css via the `expr-dj` wrapper class
 * (applied by <NovaExpression id="dj" />).
 */
import * as React from "react";

export function NovaDJ({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nova the DJ">
      
        
      <defs>
        <linearGradient id="bodyG-n4" x1="0.15" y1="0" x2="0.85" y2="1">
          <stop offset="0" stopColor="#709c9e"/>
          <stop offset="0.45" stopColor="#2D6E70"/>
          <stop offset="1" stopColor="#1e494a"/>
        </linearGradient>
        <linearGradient id="chestG-n4" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#174143"/>
          <stop offset="1" stopColor="#3a6b6d"/>
        </linearGradient>
        <radialGradient id="scrG-n4" cx="0.5" cy="0.45" r="0.8">
          <stop offset="0" stopColor="#0E1626"/>
          <stop offset="0.72" stopColor="#0E1626"/>
          <stop offset="1" stopColor="#060A12"/>
        </radialGradient>
        <pattern id="pxg-n4" width="9" height="9" patternUnits="userSpaceOnUse">
          <path d="M 9 0 L 0 0 0 9" fill="none" stroke="#060A12" strokeWidth="1.6" opacity="0.65"/>
        </pattern>
        <filter id="eglow-n4" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="6"/>
        </filter>
      </defs>
        <g transform="translate(50 0)">
        
        
        <g className="nova-body" style={{ transformOrigin: "180.00px 472.00px" }} transform="rotate(0 180 347)">
          {/* Antenna stem (drawn first so head covers its base) */}
          <line x1="180" y1="122" x2="180" y2="42.60000000000001" stroke="#1C1A17" strokeWidth="2.2" strokeLinecap="round"/>
          {/* Orbital ring (behind ball, ivory) */}
          <ellipse cx="180" cy="42.60000000000001" rx="15" ry="5.3999999999999995" stroke="#F4EFE6" strokeWidth="1.6" fill="none" transform="rotate(-12 180 42.60000000000001)"/>
          {/* Antenna ball */}
          <circle className="antenna-ball" cx="180" cy="42.60000000000001" r="7" fill="#D4541F"/>
          <ellipse cx="177.9" cy="40.150000000000006" rx="2.94" ry="2.1" fill="#FFFFFF" opacity="0.55"/>
          {/* Front half of orbital ring (over ball) so it appears to encircle */}
          <path d="M 165.3 43.10000000000001 A 15 5.3999999999999995 -12 0 0 194.7 40.400000000000006"
                stroke="#F4EFE6" strokeWidth="1.6" fill="none" opacity="0.95"/>
          
    
          {/* HEAD outer (glossy) */}
          <rect x="60" y="110" width="240" height="170" rx="36" fill="url(#bodyG-n4)"/>
          {/* Bezel inset (darker ring) */}
          <rect x="82" y="132" width="196" height="126" rx="28" fill="#1F5759"/>
          {/* Face screen: recessed navy display */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#scrG-n4)"/>
    
          {/* Cheeks (on teal head, flanking screen) */}
          
        <ellipse className="cheek cheek-l" cx="82" cy="230" rx="14" ry="9" fill="#E8A98D" opacity="0.5"/>
        <ellipse className="cheek cheek-r" cx="278" cy="230" rx="14" ry="9" fill="#E8A98D" opacity="0.5"/>
      
    
          {/* Eyes: glow pass + sharp pass */}
          <g filter="url(#eglow-n4)" opacity="0.75">
          <g className="eye-left"><path d="M 121.20434999999999 199 Q 146.88 164.515 172.55565 199"
                stroke="#A8C8E8" strokeWidth="11.286" strokeLinecap="round" fill="none" opacity="1"/></g>
          <g className="eye-right"><path d="M 187.44435 199 Q 213.12 164.515 238.79565000000002 199"
                stroke="#A8C8E8" strokeWidth="11.286" strokeLinecap="round" fill="none" opacity="1"/></g>
        </g>
          
          <g className="eye-left"><path d="M 121.20434999999999 199 Q 146.88 164.515 172.55565 199"
                stroke="#A8C8E8" strokeWidth="11.286" strokeLinecap="round" fill="none" opacity="1"/></g>
          <g className="eye-right"><path d="M 187.44435 199 Q 213.12 164.515 238.79565000000002 199"
                stroke="#A8C8E8" strokeWidth="11.286" strokeLinecap="round" fill="none" opacity="1"/></g>
        
    
          {/* Single quiet tear (Sad) — on face screen, below right eye */}
          
    
          {/* Pixel grid over the display (LED look) */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#pxg-n4)"/>
          {/* Screen glare */}
          <ellipse cx="146.88" cy="148" rx="55.199999999999996" ry="9" fill="#8FB4E8" opacity="0.13"/>
          {/* Head specular */}
          <ellipse cx="112" cy="126" rx="36" ry="9" fill="#FFFFFF" opacity="0.35" transform="rotate(-10 112 126)"/>
    
          {/* BODY outer (glossy) */}
          <rect x="50" y="302" width="260" height="170" rx="36" fill="url(#bodyG-n4)"/>
          {/* Chest storage: interior + items behind a hinged door */}
          <rect x="72" y="324" width="216" height="126" rx="26" fill="#0B1220"/>
          <g className="chest-items" style={{ opacity: "0" }}>
            <path d="M 141.12 358 l 6.2 12.7 13.9 2 -10 9.8 2.4 13.9 -12.5 -6.6 -12.5 6.6 2.4 -13.9 -10 -9.8 13.9 -2 Z" fill="#D4A02C"/>
            <g transform="translate(190.8 368)">
              <rect x="0" y="0" width="44" height="30" rx="5" fill="#1C1A17"/>
              <circle cx="22" cy="15" r="9" fill="#3A3733" stroke="#F4EFE6" strokeWidth="1.4"/>
              <rect x="31" y="3" width="8" height="5" rx="1.5" fill="#3A3733"/>
            </g>
          </g>
          {/* Chest door (hinged at left edge) */}
          <g className="chest-door" style={{ transformOrigin: "74px 387.0px" }}>
            <rect x="72" y="324" width="216" height="126" rx="26" fill="url(#chestG-n4)"/>
            <line x1="79" y1="336" x2="79" y2="438" stroke="#0B1220" strokeWidth="2.4" opacity="0.55"/>
            <circle cx="272" cy="387.0" r="5" fill="#6d9293"/>
          </g>
          {/* Body specular */}
          <ellipse cx="98" cy="316" rx="30" ry="7" fill="#FFFFFF" opacity="0.25" transform="rotate(-8 98 316)"/>
    
          {/* Arms (drawn over body) */}
          
          <g className="float-arm float-arm-l">
            <rect x="8" y="326" width="30" height="96" rx="15" fill="url(#bodyG-n4)"/>
            <ellipse cx="18" cy="339" rx="7" ry="4" fill="#FFFFFF" opacity="0.32"/>
          </g>
          <g className="float-arm float-arm-r">
            <rect x="322" y="326" width="30" height="96" rx="15" fill="url(#bodyG-n4)"/>
            <ellipse cx="332" cy="339" rx="7" ry="4" fill="#FFFFFF" opacity="0.32"/>
          </g>
        
        </g>
        </g>
      
      <g transform="translate(50 0)">
        {/* headphone band + cups */}
        <path d="M 62 160 Q 180 42 298 160" stroke="#1C1A17" strokeWidth="14" fill="none" strokeLinecap="round"/>
        <rect x="48" y="140" width="26" height="58" rx="11" fill="#1C1A17"/>
        <rect x="286" y="140" width="26" height="58" rx="11" fill="#1C1A17"/>
        <circle cx="61" cy="169" r="6" fill="#D4A02C"/>
        <circle cx="299" cy="169" r="6" fill="#D4A02C"/>
      </g>
      {/* equalizer bars, bottom-left */}
      <g fill="#D4541F">
        <rect className="dj-bar"    x="18" y="380" width="16" height="60" rx="5"/>
        <rect className="dj-bar b2" x="42" y="360" width="16" height="80" rx="5" fill="#D4A02C"/>
        <rect className="dj-bar b3" x="66" y="390" width="16" height="50" rx="5"/>
        <rect className="dj-bar b4" x="90" y="370" width="16" height="70" rx="5" fill="#D4A02C"/>
      </g>
      {/* floating notes, right */}
      <g fill="#1C1A17">
        <g className="dj-note"><circle cx="398" cy="300" r="8"/><rect x="404" y="258" width="4" height="44" rx="2"/><path d="M 404 258 q 16 2 18 12" stroke="#1C1A17" strokeWidth="4" fill="none"/></g>
        <g className="dj-note n2"><circle cx="428" cy="340" r="6"/><rect x="432" y="308" width="3.5" height="34" rx="2"/></g>
      </g>
    </svg>
  );
}
